/** @format */

import React, { useState, useEffect } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import collapseAdd from "../../assets/images/collapsedAdd.svg";

import {
  //   addGymModal,
  addTrainerModal,
  addUserModal,
  addWodModal,
  addPackageModal,
  addSaleModal,
  addStaffModal,
  addAppointmentModal,
  setRetailModal,
  addGateModal,
  addFollowupProgramModal,
  //   addAdminModal,
} from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import {
  getTrainerAttribute,
  getAllMembers,
  getPackages,
} from "../../redux/actions/api/apiAction";
import { ComonIcons } from "../../contents/commonIcons";
import { api } from "../../api/api";
import { setAddProgramModalOpen } from "../../redux/actions/trainer/trainerAction";
import { toastr } from "react-redux-toastr";
import { setOpenLeadModal } from "../../redux/actions/lead/leadAction";
import { setVoiceAdd } from "../../redux/reducers/voiceAdd/voiceAddReducer";
import VoiceAdd from "../voiceAdd/VoiceAdd";
const AddDropdown = (props) => {
  const { features, gymFeaturesObject } = useSelector((state) => state.features);
  const voiceAddEnabled = Boolean(gymFeaturesObject && gymFeaturesObject.voiceAdd);
  const { gym, gymConfig } = useSelector((state) => state.gym);
  const { loginUser } = useSelector((state) => state.login);
  const { currentStaffActiveSession } = useSelector(
    (state) => state.staffSession
  );

  const [dropdownOpen, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [role, setRole] = useState();
  const showGatesFeature =
    !role || role === "STAFF"
      ? store.getState().permissions.permissions["S-GATES-FEAT"] ||
        store.getState().permissions.subAdminPermissions["S-GATES-FEAT"]
        ? true
        : false
      : true;
  const canAddCourt =
    !(
      loginUser &&
      loginUser.role === "STAFF" &&
      store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
      !store.getState().permissions.permissions["S-COURT-ADD"]
    ) &&
    !(
      store.getState().permissions.subAdminType === "SUB_ADMIN" &&
      !store.getState().permissions.subAdminPermissions["S-COURT-ADD"]
    );

  useEffect(() => {
    let login = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    if (login?.isSuperGymAdmin && login.isSubAdmin) setRole("STAFF");
    else
      setRole(
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role
      );
  }, [dispatch]);

  const toggle = () => setOpen(!dropdownOpen);
  const getPackage = async (page, limit, trainerId = "") => {
    let url = `package?page=${page}&limit=${limit}&trainer=${trainerId}`;
    let res = await api(url, {}, "get");
    if (res.status === 400) return [];
    return res.data.data;
  };
  const getPermissions = async () => {
    let url = "permission?type=STAFF";
    let res = await api(url, {}, "get");
    if (res.status === 400) return [];
    return res.data.data;
  };
  return (
    <ButtonDropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className={`${!props.collapsed ? "w-100" : ""}`}
    >
      {!props.collapsed ? (
        <DropdownToggle
          caret
          className="custom-dropdown-button w-100"
          color="transparent"
        >
          Add
        </DropdownToggle>
      ) : (
        <DropdownToggle
          caret
          color="transparent"
          className="collapsed-dropdown"
        >
          <img src={collapseAdd} />
        </DropdownToggle>
      )}
      <DropdownMenu className="add-dropdown-menu">
        {role === "TRAINER" && (
          <DropdownItem
            onClick={() => {
              dispatch(setAddProgramModalOpen(true));
            }}
          >
            <span className="block-1">{ComonIcons.program}</span>
            <span className="block-2">Add Program</span>
          </DropdownItem>
        )}
        {gymConfig?.manageMemberships?.enabled && gymConfig?.manageMemberships?.classMemberships?.enabled && ((role == "STAFF" &&
          store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
          !store.getState().permissions.permissions["S-SERV-PROD"]) ||
        role === "TRAINER" ||
        (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
          !store.getState().permissions.subAdminPermissions[
            "S-SERV-PROD"
          ]) ? null : (
          <DropdownItem
            onClick={() => {
              props.addPrivateModal();
            }}
          >
            <span className="block-1">{ComonIcons.appointment}</span>
            <span className="block-2">
              {gym.type == "sportClub" ? "Add Group Session" : "Add Class"}
            </span>
          </DropdownItem>
        ))}
        {gymConfig?.manageMemberships?.enabled && gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled && ((role == "STAFF" &&
          store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
          !store.getState().permissions.permissions["S-SERV-PROD"]) ||
          role === "TRAINER" ||
          (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
            !store.getState().permissions.subAdminPermissions[
            "S-SERV-PROD"
            ]) ? null : (
          <DropdownItem
            onClick={() => {
              props.addWorkshopModal();
            }}
          >
            <span className="block-1">{ComonIcons.workshop}</span>
            <span className="block-2">Add Workshop</span>
          </DropdownItem>
        ))}
        {gym.type == "sportClub" && canAddCourt && (
          <DropdownItem
            onClick={() => {
              props.setCourtModal();
            }}
          >
            <span className="block-1">{ComonIcons.court}</span>
            <span className="block-2">Add Court</span>
          </DropdownItem>
        )}
        {gym.type == "complex" && canAddCourt && (
          <DropdownItem
            onClick={() => {
              props.setCourtModal();
            }}
          >
            <span className="block-1">{ComonIcons.gate}</span>
            <span className="block-2">Add Room</span>
          </DropdownItem>
        )}
        {(props.LoggedInRole === "PT" ||
          role == "GYM" ||
          role == "STAFF" ||
          store.getState().permissions.subAdminType == "SUB_ADMIN") && (
            <>
              {(role == "STAFF" &&
                store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                !store.getState().permissions.permissions["S-M-ADD"]) ||
                (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                  !store.getState().permissions.subAdminPermissions[
                  "S-M-ADD"
                  ]) ? null :
                (gymConfig?.manageMembers?.enabled &&
                  (
                    <DropdownItem
                      onClick={async () => {
                        if (props.LoggedInRole === "PT") {
                          let trainerId = JSON.parse(
                            localStorage.getItem("connectToFitGymPanelUser")
                          ).trainer;
                          let pakage = await getPackage(1, 999999, trainerId);
                          props.setPackages(pakage);
                        } else {
                          await dispatch(getPackages(1, 999999));
                        }
                        dispatch(setVoiceAdd({ prefill: null }));
                        dispatch(addUserModal(true));
                      }}
                    >
                      <span className="block-1">{ComonIcons.members}</span>
                      <span className="block-2">Add Member</span>
                    </DropdownItem>
                  )
                )
              }
            {
              gymConfig?.leadManagement?.enabled &&
                  (
                    <DropdownItem
                      onClick={async () => {
                         dispatch(setOpenLeadModal(true))
                      }}
                    >
                      <span className="block-1">{ComonIcons.members}</span>
                      <span className="block-2">Add Lead</span>
                    </DropdownItem>
                  )

            }

              {(gymConfig?.manageMemberships?.enabled || gymConfig?.retail?.enabled) &&
                ((role == "STAFF" &&
                  store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                  !store.getState().permissions.permissions["S-SAL-ADD"] &&
                  !store.getState().permissions.permissions["S-SAL-PRO"]) ||
                  (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                    !store.getState().permissions.subAdminPermissions["S-SAL-ADD"] &&
                    !store.getState().permissions.subAdminPermissions[
                    "S-SAL-PRO"
                    ]) ? null : (
                  <DropdownItem
                    onClick={async () => {
                      if (gymConfig?.switchStaff?.enabled) {
                        if (!currentStaffActiveSession) {
                          toastr.error("Must Start Session In Order to Add Sale!");
                          return;
                        }
                      }
                      dispatch(addSaleModal(true, false, {}));
                    }}
                  >
                    <span className="block-1">{ComonIcons.sale}</span>
                    <span className="block-2">Add Sale</span>
                  </DropdownItem>
                ))
              }
              {gymConfig?.manageMemberships?.enabled && (gymConfig?.manageMemberships?.gymMemberships?.enabled || gymConfig?.manageMemberships?.classMemberships?.enabled || gymConfig?.manageMemberships?.appointmentMemberships?.enabled || gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled) && ((role == "STAFF" &&
                store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                !store.getState().permissions.permissions["S-PAC-ADD/D"]) ||
                (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                  !store.getState().permissions.subAdminPermissions[
                  "S-PAC-ADD/D"
                  ]) ? null : (
                  <DropdownItem
                    onClick={async () => {
                      dispatch(setVoiceAdd({ prefill: null }));
                      dispatch(addPackageModal(true, false, {}));
                    }}
                  >
                  <span className="block-1">{ComonIcons.package}</span>
                  <span className="block-2">Add Package</span>
                </DropdownItem>
              ))}
              {
                gymConfig?.retail?.enabled &&
                ((role == "STAFF" &&
                  store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                  !store.getState().permissions.permissions["S-ADD-PRO"]) ||
                  (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                    !store.getState().permissions.subAdminPermissions["S-ADD-PRO"]) ? null : (
                  <DropdownItem
                    onClick={async () => {
                      dispatch(setRetailModal(true, false, {}));
                    }}
                  >
                    <span className="block-1">{ComonIcons.product}</span>
                    <span className="block-2">
                      {gym.type == "sportClub" ? "Add Service" : "Add Product"}
                    </span>
                  </DropdownItem>
                ))
              }
            </>
          )}
        {role == "GYM" ||
          role == "STAFF" ||
          store.getState().permissions.subAdminType == "SUB_ADMIN" ? (
          <>
            {
              gymConfig?.manageInstructors?.enabled &&
              ((role == "STAFF" &&
                store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                !store.getState().permissions.permissions["S-I-ADD"]) ||
                (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                  !store.getState().permissions.subAdminPermissions["S-I-ADD"]) ? null : (
                <DropdownItem
                  onClick={async () => {
                    //console.log('work');
                    dispatch(getTrainerAttribute());
                    dispatch(addTrainerModal(true));
                  }}
                >
                  <span className="block-1">{ComonIcons.trainer}</span>{" "}
                  <span className="block-2">
                    {gym.type == "sportClub"
                      ? "Add Coach"
                      : gym.type == "complex"
                        ? "Add Instructor"
                        : "Add Instructor"}
                  </span>
                </DropdownItem>
              ))
            }

            {gymConfig?.manageMemberships?.enabled && gymConfig?.manageMemberships?.appointmentMemberships?.enabled && ((role == "STAFF" &&
              store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
              store.getState().permissions.permissions["S-SERV-PROD"]) ||
              (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                store.getState().permissions.subAdminPermissions[
                "S-SERV-PROD"
                ]) ||
              (role == "GYM" &&
                store.getState().permissions.subAdminType !== "SUB_ADMIN") ? (
              <DropdownItem
                onClick={async () => {
                  dispatch(addAppointmentModal(true));
                }}
              >
                <span className="block-1">{ComonIcons.appointments}</span>
                <span className="block-2">
                  {gym.type == "sportClub"
                    ? "Add Private Lesson"
                    : "Add Appointment"}
                </span>
              </DropdownItem>
            ) : null)}
            {
              gymConfig?.manageStaff?.enabled && (
                (role == "STAFF" &&
                  store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                  !store.getState().permissions.permissions["S-S-MNG"]) ||
                  (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                    !store.getState().permissions.subAdminPermissions["S-S-MNG"]) ? null : (
                  <DropdownItem
                    onClick={async () => {
                      let allPermissons = await getPermissions();
                      dispatch(addStaffModal(true, false, {}));
                      props.staffPermissons(allPermissons);
                    }}
                  >
                    <span className="block-1">{ComonIcons.staff}</span>
                    <span className="block-2">Add Staff</span>
                  </DropdownItem>
                )
              )
            }
            {
              gymConfig?.workouts?.enabled &&
              ((role == "STAFF" &&
                store.getState().permissions.subAdminType !== "SUB_ADMIN" &&
                !store.getState().permissions.permissions["S-W-ADD"]) ||
                (store.getState().permissions.subAdminType == "SUB_ADMIN" &&
                  !store.getState().permissions.subAdminPermissions["S-W-ADD"]) ? null : (
                <DropdownItem
                  onClick={async () => {
                    //  alert(value.id)
                    await store.dispatch(
                      getAllMembers(
                        JSON.parse(
                          localStorage.getItem("connectToFitGymPanelUser")
                        ).gym
                      )
                    );
                    dispatch(addWodModal(true));
                  }}
                >
                  <span className="block-1">{ComonIcons.wod}</span>
                  <span className="block-2">Add Workout</span>
                </DropdownItem>
              ))
            }
            {
              gymConfig?.followupProgram?.enabled &&
              (
                <DropdownItem
                  onClick={async () => {
                    dispatch(addFollowupProgramModal(true));
                  }}
                >
                  <span className="block-1">{ComonIcons.followupProgram}</span>
                  <span className="block-2">Add Follow-up Program</span>
                </DropdownItem>
              )
            }
            {gymConfig?.gates?.enabled && showGatesFeature && (
              <DropdownItem
                onClick={async () => {
                  await store.dispatch(
                    getAllMembers(
                      JSON.parse(
                        localStorage.getItem("connectToFitGymPanelUser")
                      ).gym
                    )
                  );
                  dispatch(addGateModal(true));
                }}
              >
                <span className="block-1">{ComonIcons.gate}</span>
                <span className="block-2">Add Gate</span>
              </DropdownItem>
            )}
          </>
        ) : (
          ""
        )}
      </DropdownMenu>
      {voiceAddEnabled && (
        <VoiceAdd
          loggedInRole={props.LoggedInRole}
          openClass={() => props.addPrivateModal && props.addPrivateModal()}
          openWorkshop={() => props.addWorkshopModal && props.addWorkshopModal()}
          openCourt={() => props.setCourtModal && props.setCourtModal()}
          onStaffPermissions={props.staffPermissons}
        />
      )}
    </ButtonDropdown>
  );
};

export default AddDropdown;
